import { render, staticRenderFns } from "./FormActivos.vue?vue&type=template&id=ed4ff2e2&"
import script from "./FormActivos.vue?vue&type=script&lang=js&"
export * from "./FormActivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports